// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar-container","avatarContainer":"Avatar-avatarContainer"};